import { toast } from "react-toastify";

// toast success message
export const notifySuccess = (message) => {
  toast(message, {
    type: "success",
    position: "top-right",
  });
};

// toast error message
export const notifyError = (message) => {
  toast(message, {
    type: "error",
    position: "top-right",
  });
};
